module.exports = __webpack_public_path__ + "img/loginpage.662cc72e.png";